/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Share Icon component.
 */
export const SystemShareIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='11.9998' cy='2.33333' r='1.58333' stroke={iconColor} strokeWidth='1.5' />
      <circle cx='11.9998' cy='13.6668' r='1.58333' stroke={iconColor} strokeWidth='1.5' />
      <circle cx='3.33333' cy='8.33333' r='1.58333' stroke={iconColor} strokeWidth='1.5' />
      <line x1='9.95994' y1='12.8745' x2='5.20795' y2='9.70654' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='10.3041' y1='4.15489' x2='5.35807' y2='7.01048' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default SystemShareIcon;
